import React, { useState } from 'react';

const Search_bar = () => {
  const [searchTerm, setSearchTerm] = useState('');

  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    // Search action
    console.log('Search term:', searchTerm);
  };

  return (
    <div id="popup-search" className="page-popup page-search-popup">
      <div id="search-popup-close" className="popup-close-button">
        <div className="burger-icon">
          <span className="burger-icon-top"></span>
          <span className="burger-icon-bottom"></span>
        </div>
      </div>
      <div className="page-search-popup-content">
        <form role="search" method="get" className="search-form" onSubmit={handleSubmit}>
          <label>
            <span className="screen-reader-text">Search for:</span>
            <input
              type="search"
              className="search-field"
              placeholder="Search…"
              value={searchTerm}
              onChange={handleSearchChange}
              name="s"
              title="Search for:"
              style={{
                padding: '10px',
                fontSize: '16px',
                width: '100%',
                border: '1px solid #ccc',
                borderRadius: '4px'
              }}
            />
          </label>
          <button
            type="submit"
            className="search-submit"
            style={{
              padding: '10px 20px',
              fontSize: '16px',
              backgroundColor: '#007bff',
              color: '#fff',
              border: 'none',
              borderRadius: '4px',
              cursor: 'pointer'
            }}
          >
            <span className="search-btn-icon far fa-search"></span>
            <span className="search-btn-text">Search</span>
          </button>
        </form>
      </div>
    </div>
  );
};

export default Search_bar;


